export const environment = {
    production: true,
    serverDomain: 'http://127.0.0.1:4000',
    clientDomain: 'https://www.jsdaddy.io',
    sentry: {
        env: 'prod',
    },
};
